import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';
/*
 * Capitalizes the first letter of a string.
*/
@Pipe({name: 'aoran'})
export class AorAnPipe implements PipeTransform {
  transform(value: any): string {
    const vowels = ['a', 'e', 'i', 'o', 'u'];
    if (isNil(value)) {
      return value;
    }
    const valuelc = (value as string).toLowerCase();

    if (vowels.includes(valuelc[0])) {
      return `an ${value}`;
    }

    if (valuelc.slice(0, 2) === 'ho') {
      return `an ${value}`;
    }

    return `a ${value}`;
  }
}
